module.exports = __webpack_public_path__ + "img/phone.e3dbc945.svg";